import model from "../model";

export default {
    mounted(element: HTMLElement){
        element.classList.add(model.bonusPointsType);
    },
};